// import { Button } from 'antd';
import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';
import './styles.scss';

function WarningModal(props) {
  const { onOk, onCancel, visible, message = '', title = '', disableOnOk, replaceWithComponent = undefined, resourcesTabConfirmation } = props;
  return (
    <Modal
      isOpen={visible}
      backdrop={(true, 'static')}
      onOpened={() => {
        document.body.style.overflow = 'hidden';
      }}
      onClosed={() => {
        document.body.style.overflow = 'auto';
      }}
      onExit={() => {
        document.body.style.overflow = 'auto';
      }}
      toggle={onCancel}
      className="modal-dialog-centered"
    >
      <ModalHeader toggle={onCancel}>
        {title}
      </ModalHeader>
      <ModalBody style={{ overflow: resourcesTabConfirmation && 'auto' }}>
        <p style={{ width: resourcesTabConfirmation && 461 }}>{message}</p>
        {replaceWithComponent && replaceWithComponent()}
      </ModalBody>
      <ModalFooter>
        <Button type="default" onClick={onCancel}>
          Cancel
        </Button>
        <Button color="primary" type="primary" style={{ borderRadius: '4px' }} disabled={disableOnOk || false} onClick={onOk}>
          Ok
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default WarningModal;
